export const PIPE = '|';
export const UNION = '\u222A';
export const PLUS = '+';
export const LOGICAL_OR = '\u2228';


// WEBPACK FOOTER //
// ./src/constants/alternationSymbols.js